import { useId } from "react";

import { FormControl } from "./FormControl";
import { Input } from "./Input";

export const TextField: React.FC<
  Pick<React.ComponentProps<typeof FormControl>, "label" | "error" | "hint"> &
    React.ComponentProps<typeof Input>
> = ({ label, error, hint, ...props }) => {
  const id = useId();
  return (
    <FormControl id={id} label={label} error={error} hint={hint}>
      <Input id={id} {...props} />
    </FormControl>
  );
};
